import { Injectable } from "@angular/core";
import { RisrFormTypeExpander, RisrExpandableField, RisrSchemaField } from "@fry-it/risr-core";

/**
 * This expander is responsible for expanding event type fields
 *
 * @category Forms
 * @example
 * ```typescript
 * const field = {
 *     id: 'id',
 *     label: 'Select event types',
 *     expandType: 'event_type',
 *     required: true,
 *     initialValue: []
 * };
 * const expanded = await this.formExpander.expand(field);
 * ```
 */
@Injectable()
export class EventStateFieldExpander implements RisrFormTypeExpander {
    provideTypes: string[] = ['eventState'];
    async expand(field: RisrExpandableField): Promise<RisrSchemaField> {
        return {
            name: field.id,
            label: field.label,
            type: 'discrete_multiple',
            required: field.required,
            options: {
                categories: [
                    {"name": "complete", "label": "Complete"},
                    {"name": "submitted", "label": "Submitted"}
                ]
            },
            initialValue: field.initialValue
        }
    }
}